import type { MenuProduct, StationSettings } from '../shared/domain';
import { customerCategory, customerDrinkKey, customerHours } from '../shared/customerMenu';
import { withLegacyDrinkGroups } from '../shared/drinkGroups';
import { translate, type Locale } from './i18n';

export function customerMenu(products: MenuProduct[]): MenuProduct[] {
  return withLegacyDrinkGroups(products).map(p => ({ ...p,
    category: customerCategory(p.category),
    ...(p.drink ? { drink: { ...p.drink, category: customerCategory(p.drink.category) } } : {}),
    // Approved unpriced snapshots predate Less Ice. They remain unpriced; current
    // live quote validation is required once this item becomes orderable.
    ...(p.browseOnly && p.temperature === 'iced' && p.options.ice.includes('normal') && !p.options.ice.includes('less') ? { options: { ...p.options, ice: [...p.options.ice, 'less'] } } : {}),
  }));
}
export function drinkDescription(locale: Locale, name: string, description: string) {
  const key = customerDrinkKey(name);
  const preparation = /resep awal|uji rasa|recipe in development|test recipe/i.test(description);
  const legacyDescriptions = ['Espresso dan air. Bersih, ringan, tetap berkarakter.', 'Espresso yang lembut dengan susu segar.', 'Espresso, susu segar, dan manis hangat gula aren.', 'Recipe and price in preparation. / Resep dan harga dalam persiapan.'];
  // Honor deliberate Admin descriptions; translate the supported standard copy
  // and replace only legacy preparation/default text without catalog writes.
  if (key && (!description.trim() || preparation || legacyDescriptions.includes(description) || ['en', 'id'].some(language => description === translate(language as Locale, `drink.${key}`)))) return translate(locale, `drink.${key}`);
  if (preparation) return translate(locale, 'menu.descriptionPending');
  return description;
}
export function drinkName(locale: Locale, name: string) {
  return name.replace(/\s*[—–-]\s*(Hot|Iced|Panas|Dingin)$/i, (_, temp: string) => ` — ${translate(locale, ['hot', 'panas'].includes(temp.toLowerCase()) ? 'temperature.hot' : 'temperature.iced')}`);
}
export function hoursLabel(locale: Locale, hours: StationSettings['openingHours']) {
  const effective = customerHours(hours);
  const weekdays = effective.filter(h => !h.closed);
  if (weekdays.length === 5 && weekdays.every(h => h.day >= 1 && h.day <= 5 && h.open === '09:00' && h.close === '17:00')) return translate(locale, 'menu.hours');
  if (!weekdays.length) return translate(locale, 'menu.noHours');
  const days = locale === 'id' ? ['Minggu','Senin','Selasa','Rabu','Kamis','Jumat','Sabtu'] : ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
  return [...weekdays].sort((a,b) => a.day-b.day).map(h => `${days[h.day]} ${h.open}–${h.close}`).join(' · ') + ' WIB';
}
